import { DialogRef } from '@angular/cdk/dialog';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { BusApiService } from 'src/app/services/api/bus-api.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-refund-wallet-modal',
  templateUrl: './refund-wallet-modal.component.html',
  styleUrls: ['./refund-wallet-modal.component.scss'],
})
export class RefundWalletModalComponent implements OnInit {
  loading = false;

  constructor(
    private dialogRef: DialogRef<RefundWalletModalComponent>,
    private api: BusApiService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private message: MessageService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.getRefundAmount();
  }

  async refund() {
    try {
      this.loading = true;
      const r = await this.api.refundWallet(this.data.id);
      if (r.status === 0) {
        this.message.open('退款成功');
        this.dialogRef.close();
        this.router
          .navigateByUrl('/', { skipLocationChange: true })
          .then(() => {
            this.router.navigate(['/user/profile/seats']);
          });
      } else if (r.status === 12010) {
        this.message.warn('兑换钱包失败');
      }
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }

  amount = 0;
  async getRefundAmount() {
    try {
      this.loading = true;
      const r = await this.api.getRefundAmount(this.data.id);
      this.amount = r.data;
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }
}
